export default __webpack_public_path__ + "static/media/hd_ic_support.8fc69bcb.svg";